export const getSharedDomain = () => {
  if (window.location.host.includes('localhost') || window.location.host.includes('127.0.0.1')) {
    return 'localhost';
  } else {
    return `${window.location.host}`.replace('profile', '');
  }
};
